// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-templates-brand-js": () => import("/opt/render/project/src/src/templates/brand.js" /* webpackChunkName: "component---src-templates-brand-js" */),
  "component---src-templates-model-js": () => import("/opt/render/project/src/src/templates/model.js" /* webpackChunkName: "component---src-templates-model-js" */),
  "component---src-pages-404-js": () => import("/opt/render/project/src/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-brands-index-js": () => import("/opt/render/project/src/src/pages/brands/index.js" /* webpackChunkName: "component---src-pages-brands-index-js" */),
  "component---src-pages-index-js": () => import("/opt/render/project/src/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-page-2-js": () => import("/opt/render/project/src/src/pages/page-2.js" /* webpackChunkName: "component---src-pages-page-2-js" */)
}

